export const GET_FEE_CATEGORIES = "GET_FEE_CATEGORIES";
export const CREATE_FEE_CATEGORIES = "CREATE_FEE_CATEGORIES";
export const GET_THIRD_PARTY_BENEFICIARIES = "GET_THIRD_PARTY_BENEFICIARIES";
export const CREATE_FEE_CATEGORIES_ERROR = "CREATE_FEE_CATEGORIES_ERROR";
